export interface ICaseComment {
  caseCommentType: string;
  caseId: number;
  content: string;
  createdAt: string;
  createdBy: string
  id: number;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
  replyCount: number;
  childs: ICaseComment[];
}

export enum COMMENT_TYPES {
  Comment = 'Comment',
  ChatConversation = 'ChatConversation',
  ChatMessage = 'ChatMessage',
  Email = 'Email'
}
